import "./chipList.scss"

interface IChip {
    text: string;
  }
  
  export default function Chip({ text }: IChip) {
    return (
      <div className="chip">{text}</div>
    );
  }
  